<template>
  <el-select class="td_select"
             style="width: 100%"
             :title="values.mdmCode + ' ' + values.customerName"
             v-model="values"
             value-key="mdmCode"
             default-first-option
             filterable
             remote
             reserve-keyword
             :placeholder="placeholder"
             :clearable="clearable"
             :disabled="disabled"
             :remote-method="remoteMethod"
             @clear="clearClick"
             :loading="loading">
    <el-option
        class="td_option"
        v-for="(item, index) in options"
        :key="index"
        :label="item.mdmCode+ '  ' +item.customerName"
        :value="{ mdmCode: item.mdmCode, customerName: item.customerName }"
        @click.native="handleSelect(item)">
      <span style="float: left;width: 130px;"><i class="fa fa-gg-circle" :style="{'color':item.sourceType==='cus'?'#f78989':'#66b1ff','margin-right': '5px'}"></i>{{ item.mdmCode }}</span>
      <span style="float: left; color: #8492a6; font-size: 13px;">{{ item.customerName }}</span>
    </el-option>
  </el-select>
</template>
<script>
import { haireOjbName } from '@/api/basic/comlist'
import { validatenull } from '@/tdcommon/validate'

export default {
  name: 'd2-container-mdmselect',
  data () {
    return {
      values: {},
      options: [],
      loading: false,
      mdmStrMark: ''
    }
  },
  props: {
    value: {
      type: String,
      default: () => ''
    },
    clearable: {
      type: Boolean,
      default: () => false
    },
    disabled: {
      type: Boolean,
      default: () => false
    },
    placeholder: {
      type: String,
      default: () => '请输入关键词'
    },
    sourcetype: {
      type: String,
      default: () => ''
    },
    mdmstr: {
      type: String,
      default: () => ''
    },
    payMdmVal: {
      type: String,
      default: () => ''
    }
  },
  methods: {
    remoteMethod (query) {
      this.loading = true
      var Searchquery = validatenull(query) ? '' : query
      haireOjbName(Searchquery, this.sourcetype).then(response => {
        this.loading = false
        if (response.code === 0) {
          this.options = response.data
        }
      }).catch(() => {
        this.loading = false
      })
    },
    handleSelect (val) {
      this.values = { mdmCode: val.mdmCode, customerName: val.customerName }
      this.$emit('change', val)
    },
    clearClick (val) {
      this.$emit('change', '')
    },
    getStartValues (val) {
      console.log('getStartValues', val)
      console.log('getStartValues-this.mdmstr', this.mdmstr)
      console.log('getStartValues-this.payMdmVal', this.payMdmVal)
      if (!validatenull(this.payMdmVal)) {
        this.values = Object.assign({ mdmCode: this.payMdmVal, customerName: val })
      } else if (!validatenull(this.mdmstr)) {
        let model = this.$parent.elForm.model[this.mdmstr]
        console.log('getStartValues-model', model)
        if (!validatenull(model)) {
          this.values = Object.assign({ mdmCode: model, customerName: val })
        } else {
          this.values = Object.assign({ mdmCode: '', customerName: val })
        }
      }
    }
  },
  watch: {
    values: function (val, oldVal) {
      console.log('values', val)
      this.$emit('input', validatenull(val) ? '' : val.customerName)
    },
    value: function (val, oldVal) {
      console.log('value-val', val)
      console.log('value-oldVal', oldVal)
      console.log('this.options', this.options)
      if (!validatenull(this.options) && val !== oldVal) {
        this.remoteMethod(val)
        this.getStartValues(val)
      }
    }
  },
  mounted () {
    this.remoteMethod(this.value)
    this.getStartValues(this.value)
  }
}
</script>

<style lang="scss" scoped>
</style>

<vue-filename-injector>
export default function (Component) {
  Component.options.__source = "src/components/d2-container-mdmselect/index.vue"
}
</vue-filename-injector>
